// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function MM_cmp_export_state_to_json(props) {
  var onClose = props.onClose;
  var match = Local_storage_utils.useStateFromLocalStorageBool("export-to-json-append-timestamp", false);
  var setAppendTimestamp = match[1];
  var appendTimestamp = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setCopiedToClipboard = match$1[1];
  var timestampStr = appendTimestamp ? Common.currTimeStr(undefined) + " " : "";
  var textToShow = timestampStr + props.jsonStr;
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        children: Caml_option.some(null)
                      }, React.createElement(Expln_React_Row.make, {
                            alignItems: "center",
                            children: Caml_option.some(null)
                          }, React.createElement(FormControlLabel, {
                                control: React.createElement(Checkbox, {
                                      checked: appendTimestamp,
                                      onChange: (function (param) {
                                          return Expln_React_common.evt2bool((function (b) {
                                                        Curry._1(setAppendTimestamp, (function (param) {
                                                                return b;
                                                              }));
                                                      }), param);
                                        })
                                    }),
                                label: "append timestamp"
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    MM_react_common.copyToClipboard(textToShow);
                                    Curry._1(setCopiedToClipboard, (function (timerId) {
                                            if (timerId !== undefined) {
                                              Common.$$clearTimeout(Caml_option.valFromOption(timerId));
                                            }
                                            return Caml_option.some(Common.$$setTimeout((function (param) {
                                                              Curry._1(setCopiedToClipboard, (function (param) {
                                                                      
                                                                    }));
                                                            }), 1000));
                                          }));
                                  }),
                                variant: "contained",
                                style: {
                                  width: "90px"
                                },
                                children: Caml_option.some(Belt_Option.isSome(match$1[0]) ? "Copied" : "Copy")
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    Curry._1(onClose, undefined);
                                  }),
                                children: "Close"
                              })), React.createElement("pre", {
                            style: {
                              overflow: "auto"
                            }
                          }, textToShow)))
            });
}

var make = MM_cmp_export_state_to_json;

exports.make = make;
/* react Not a pure module */
